import type { Product } from '../../../data/product';
import { compare } from '../../../helpers/column-sort';
import { defineColumn, type StrictColumnDef } from '../../tanstack-table/column';

export const SizeOunces: StrictColumnDef<Product> = defineColumn<Product>({
  id: 'Size (oz)',
  minWidth: 60,
  accessorFn: (product) => `${product.size_ounces}`,
  sortingFn: (rowA, rowB) => compare(rowA.size_ounces, rowB.size_ounces),
});
